import { render, staticRenderFns } from "./ResendVerificationDialog.vue?vue&type=template&id=112364c6&lang=pug&"
import script from "./ResendVerificationDialog.vue?vue&type=script&lang=ts&"
export * from "./ResendVerificationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports